import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import InviteBanner from './InviteBanner'
import InviteShare from './InviteShare'
import InviteList from './InviteList'
import InviteTips from './InviteTips'
import {Page, WKError} from '../../../components'
import {WKPreload} from '../../../components/wk'
import {isLZWKAPP, getJsonFromUrl} from '../../../utils'
import {shareUrl} from '../../../utils/connectApp'

import "../../../css/page/InviteNewUserPage.css"


class InviteNewUserPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initialized: false,
            recordInitialized: false
        }
        this.shareClickHandle = this.shareClickHandle.bind(this)
        this.reqAccept = this.reqAccept.bind(this)
    }

    componentDidMount() {
        let paramJson = getJsonFromUrl()
        if(paramJson && paramJson.invite_code) {
            this.reqAccept()
        }

        axios.get(`/api/marketing/channel_invitation/init`)
            .then(res => {
                let code = res.data && res.data.code
                if (code === 0) {
                    let {invite_code, share_info} = res.data.data
                    this.props.dispatch({
                        type: 'UPDATE_SHARE_DATA',
                        payload: {
                            title: share_info.share_title,
                            desc: share_info.share_description,
                            imgUrl: share_info.share_icon,
                            link: share_info.share_url,
                        }
                    });
                    this.setState({inviteCode: invite_code, shareInfo: share_info, initialized: true})
                } else {
                    this.setState({initialized: true})
                    this.page.showAlert(res.data.msg)
                }
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.status) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '服务器出现拥挤了，请联系管理员',
                            href: '/?st=app_inviter_error',
                            btn: '去首页看看'
                        }
                    })
                }
            })

        axios.get(`/api/marketing/channel_invitation/list`)
            .then(res => {
                let code = res.data && res.data.code
                if (code === 0) {
                    let {records} = res.data.data
                    this.setState({records, recordInitialized: true})
                } else {
                    this.setState({recordInitialized: true})
                    this.page.showAlert(res.data.msg)
                }
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.status) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '服务器出现拥挤了，请联系管理员',
                            href: '/?st=app_inviter_error',
                            btn: '去首页看看'
                        }
                    })
                }
            })
    }

    reqAccept() {
        let params = location.search
        axios.get(`/api/marketing/channel_invitation/accept_init${params}`)
            .then(res => {
                let code = res.data && res.data.code
                if (code !== 0) {
                    this.page.showAlert(res.data.msg)
                }
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.status && error.response.status !== 401) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '服务器出现拥挤了，请联系管理员',
                            href: '/?st=app_inviter_error',
                            btn: '去首页看看'
                        }
                    })
                }
            })
    }

    shareClickHandle() {
        if (isLZWKAPP()) {
            const {shareInfo} = this.state
            shareUrl({
                title: shareInfo.share_title,
                desc: shareInfo.share_description,
                url: shareInfo.share_url,
                icon: shareInfo.share_icon
            })
        } else {
            this.page.showAlert('点击右上角，分享给好友/朋友圈')
        }
    }

    render() {
        const {initialized, recordInitialized, records} = this.state
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="invite-new-page">
                    <WKError/>
                </div>
            )
        }

        if (!initialized || !recordInitialized) {
            return <Page parent={this} className="invite-new-page">
                <WKPreload/>
            </Page>
        }

        return <Page parent={this} className="invite-new-page">
            <InviteBanner/>
            <InviteShare shareClickHandle={this.shareClickHandle}/>
            <InviteList records={records}/>
            <div className="invite-splice"/>
            <InviteTips/>
        </Page>
    }
}

export default connect((state) => ({
    error: state.error
}))(InviteNewUserPage)


// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteNewUserPage.js